/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { validateValidations } from "api/Empresa.service"
import cesionesService from "common/services/CesionService"
import EmpresaService from "common/services/EmpresaService"
import FacturaService from "common/services/FacturaService"
import PagareService from "common/services/PagareService"
import notification from "common/utils/notification"
import { getListadoUsuarioPaginated } from "features/User/pages/RoleManagement/services/users"
import UserService from "features/User/services/UserService"
import {
  AUTORIZACIONES_QUERY_ESTADO_PENDING,
  CESIONES_QUERY_ESTADO_PENDING,
} from "features/Validaciones/constants"
import { setShowModalInvalidCertificado } from "features/Validaciones/redux/slices/validationsSlice"
import i18next from "i18next"
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac...
import TagManager from "react-gtm-module"
import * as ROUTES from "routes/RoutePaths"
import { mapCurrentUser } from "../../utils"
import {
  setShowValidarEmpresaErrorModal,
  setShowValidarEmpresaLoadingModal,
} from "./empresaSlice"

const userService = new UserService()
const empresaService = new EmpresaService()

export const fetchMiUsuarioYEmpresas = createAsyncThunk(
  "user/fetchUserAndEmpresasByToken",
  // @ts-expect-error TS(6133): 'date' is declared but its value is never read.
  async (date, thunkAPI) => {
    const { data: usuario } = await userService.getUserByToken() // byCurrentUser

    TagManager.dataLayer({
      dataLayer: { event: "accesoCompletado", id_usuario: usuario?.identityId },
    })
    return { usuario: mapCurrentUser(usuario) }
  }
)

export const fetchUsuarioEmpresaActiva = createAsyncThunk(
  "user/fetchUsuarioEmpresaActiva",
  async () => {
    const { data: usuario } = await userService.getUserByToken()
    return { usuario: mapCurrentUser(usuario) }
  }
)

export const loginUsuarioExterno = createAsyncThunk(
  "user/loginUsuarioExterno",
  // @ts-expect-error TS(2339): Property 'cif' does not exist on type 'void'.
  async ({ cif, email, identityId, razonSocial }) => {
    await userService
      .loginUsuarioExterno({
        cif,
        email,
        identityId,
        razonSocial,
      })
      .catch()

    const externaltoken = sessionStorage.getItem("token")
    const externalRefreshToken = sessionStorage.getItem("refreshToken")

    const { data } = await userService.refreshTokens({
      token: externaltoken,
      refreshToken: externalRefreshToken,
    })
    sessionStorage.setItem("access_token", data.accessToken.token)
    sessionStorage.setItem("refresh_token", data.refreshToken)
    sessionStorage.setItem("expiresIn", data.accessToken.expiresIn)

    const { data: userData } = await userService.getUserByToken()

    return {
      ...mapCurrentUser(userData.empresaActiva),
    }
  }
)

export const fetchCessionPendding = createAsyncThunk(
  "user/fetchCesionPendding",
  // @ts-expect-error TS(6133): 'thunkAPI' is declared but its value is never read...
  async (_, thunkAPI) => {
    const { data } = await cesionesService.IsEmpresaActivaHasCesiones(
      `?${CESIONES_QUERY_ESTADO_PENDING}`
    )
    return data
  }
)

export const fetchAutorizacionesPendding = createAsyncThunk(
  "user/fetchAutorizacionesPendding",
  // @ts-expect-error TS(6133): 'thunkAPI' is declared but its value is never read...
  async (_, thunkAPI) => {
    const { data: hasFacturas } =
      await FacturaService.IsEmpresaActivaHasFacturasToAuthorize(
        AUTORIZACIONES_QUERY_ESTADO_PENDING
      )
    const { data: hasPagares } =
      await PagareService.IsEmpresaActivaHasPagareToAuthorize(
        AUTORIZACIONES_QUERY_ESTADO_PENDING
      )
    return hasFacturas || hasPagares
  }
)

export const fetchCesionesAny = createAsyncThunk(
  "user/fetchCesionesAny",
  // @ts-expect-error TS(6133): 'thunkAPI' is declared but its value is never read...
  async (_, thunkAPI) => {
    const { data } = await cesionesService.IsEmpresaActivaHasCesiones()
    return data
  }
)

export const login = createAsyncThunk(
  "user/login",
  // @ts-expect-error TS(2339): Property 'email' does not exist on type 'void'.
  async ({ email, password, interno = false }, thunkAPI) => {
    try {
      const loginService = interno
        ? userService.loginInternoUser
        : userService.login

      const res = await loginService({ email, password })

      sessionStorage.setItem("access_token", res.data?.accessToken?.token)
      sessionStorage.setItem("expiresIn", res.data?.accessToken?.expiresIn)
      sessionStorage.setItem("refresh_token", res.data?.refreshToken)
      sessionStorage.setItem("isUserInterno", interno)

      thunkAPI.dispatch(fetchMiUsuarioYEmpresas(interno))
      thunkAPI.dispatch(fetchCessionPendding())
      thunkAPI.dispatch(fetchAutorizacionesPendding())
      thunkAPI.dispatch(fetchCesionesAny())
      return {
        ...res.data,
        success: true,
      }
    } catch (e) {
      return {
        success: false,
      }
    }
  }
)

export const sendResetPasswordConfirmation = createAsyncThunk(
  "user/sendResetPasswordConfirmation",
  async (email) => {
    await userService.sendResetPasswordToEmail(email)
    notification.success({
      body: `${i18next.t("notification.recuperatePasswordMsgSend")}`,
    })
  }
)

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  // @ts-expect-error TS(2339): Property 'password' does not exist on type 'void'.
  async ({ password, token, userId }) => {
    await userService.resetPassword({ password, token, userId })
    notification.success({
      body: `${i18next.t("notification.passwordCorrectUpdate")}`,
    })
    window.location.href = ROUTES.LOGIN_BACKUP
  }
)

export const validateEmpresa = createAsyncThunk(
  "user/validateEmpresa",
  async (_, thunkAPI) => {
    try {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const { identityId } = thunkAPI.getState().user
      await empresaService.validateEmpresa(identityId)
      thunkAPI.dispatch(setShowValidarEmpresaLoadingModal())
    } catch (e) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      thunkAPI.dispatch(setShowValidarEmpresaErrorModal())
      Promise.reject(e)
    }
  }
)

export const userValidateValidations = createAsyncThunk(
  "user/validateEmpresa",
  async (_, thunkAPI) => {
    try {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const { empresaActiva } = thunkAPI.getState().user
      validateValidations(empresaActiva.cif)
    } catch (e) {
      thunkAPI.dispatch(setShowModalInvalidCertificado(true))
      throw e
    }
  }
)

export const logoutIfUserIsAlreadyConnected = createAsyncThunk(
  "user/logoutIfUserIsAlreadyConnected",
  // @ts-expect-error TS(2339): Property 'accessToken' does not exist on type 'voi...
  async ({ accessToken }) => {
    const currentAccessToken = sessionStorage.getItem("access_token")
    const logout = currentAccessToken !== accessToken

    if (logout) {
      sessionStorage.removeItem("access_token")
      sessionStorage.removeItem("refresh_token")
      sessionStorage.removeItem("isUserInterno")
    }

    return {
      logout,
    }
  }
)

export const getUserActiveCesiones = async () => {
  const { data } = await userService.getUserCesionActive()
  return data
}

export const userIsVerificado = createAsyncThunk(
  "user/isVerificado",
  async (currentUser) => {
    const data = await getUserActiveCesiones()
    if (typeof currentUser === "string") {
      window.location.replace(data ? ROUTES.DASHBOARD : "")
    } else {
      return currentUser
    }
  }
)

export const userIsNotVerificado = createAsyncThunk(
  "user/isNotVerificado",
  async (msg, thunkAPI) => {
    thunkAPI.dispatch(setShowValidarEmpresaErrorModal(msg))
  }
)

export const fethDepartamentosBySelectFilter = createAsyncThunk(
  "user/isNotVerificado",
  async (msg, thunkAPI) => {
    thunkAPI.dispatch(setShowValidarEmpresaErrorModal(msg))
  }
)

export const manageLoginFromExternalApp = createAsyncThunk(
  "user/login/external",
  async (
    {
      // @ts-expect-error TS(2339): Property 'token' does not exist on type 'void'.
      token,
      // @ts-expect-error TS(2339): Property 'refreshToken' does not exist on type 'vo...
      refreshToken,
      // @ts-expect-error TS(2339): Property 'isInterno' does not exist on type 'void'...
      isInterno,
      // @ts-expect-error TS(2339): Property 'empresaNif' does not exist on type 'void...
      empresaNif,
      // @ts-expect-error TS(2339): Property 'OnPostLoginSuccess' does not exist on ty...
      OnPostLoginSuccess,
      // @ts-expect-error TS(2339): Property 'OnPostLoginError' does not exist on type...
      OnPostLoginError,
    },
    // @ts-expect-error TS(6133): 'thunkAPI' is declared but its value is never read...
    thunkAPI
  ) => {
    try {
      const { data } = await userService.refreshTokens({
        token,
        refreshToken,
      })
      sessionStorage.setItem("access_token", data?.accessToken?.token)
      sessionStorage.setItem("expiresIn", data?.accessToken?.expiresIn)
      sessionStorage.setItem("refresh_token", data?.refreshToken)
      sessionStorage.setItem("isUserInterno", isInterno)
      OnPostLoginSuccess?.(empresaNif)
    } catch {
      // eslint-disable-next-line no-console
      OnPostLoginError("#ERP_ETLD1")
    }
  }
)

export const fetchUsersByFilter = createAsyncThunk(
  "user/fetchUsers",
  // @ts-expect-error TS(6133): 'thunkAPI' is declared but its value is never read...
  async (_, thunkAPI) => {
    const { data } = await getListadoUsuarioPaginated("")
    return data
  }
)

const initialState = {
  loadingUsuarioExterno: false,
  signInSuccess: false,
  loadingUserData: true,
  loadingUserEmpresas: true,
  fetching: false,
  loadingResetPassword: false,
  showLogoutModal: false,
  id: null,
  logged: false,
  userId: "",
  identityId: "",
  personaId: "",
  verificado: false,
  email: "",
  empresaActiva: {
    id: "",
    cif: "",
    direccion: "",
    cp: "",
    poblacionId: "",
    email: "",
    razonSocial: "",
    telefono: "",
    poblacion: "",
    provincia: "",
  },
  empresas: [],
  departamentos: [],
  loadingDepartamentos: false,
  isDepartamentosFilterActive: false,
  departamentosTotalCount: 0,
  invitado: false,
  externalEmpresaNif: null,
  users: [],
  cesionPendding: false,
  autorizacionesPendding: false,
  cesionAny: false,
  usersLoading: false,
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      sessionStorage.removeItem("access_token")
      sessionStorage.removeItem("refresh_token")
      state.signInSuccess = false
      state.logged = false

      return state
    },
    setUserInfo: (state, { payload }) => {
      state.id = payload.id
      state.email = payload.email
      state.empresaActiva = {
        ...state.empresaActiva,
        ...payload.empresaActiva,
        direccion: payload.empresaActiva?.direccion,
      }
    },
    setEmpresaActivaDigitosCuentasContables: (state, { payload }) => {
      state.empresaActiva = {
        ...state.empresaActiva,
        // @ts-expect-error TS(2322): Type '{ configuracion: $TSFixMe; id: string; cif: strin...
        configuracion: {
          // @ts-expect-error TS(2339): Property 'configuracion' does not exist on type 'W...
          ...state.empresaActiva.configuracion,
          digitosCuentasContables: payload,
        },
      }
    },
    setShowLogoutModal: (state, { payload }) => {
      state.showLogoutModal = payload
    },
    setLoadingUsuarioExterno: (state, { payload }) => {
      state.loadingUsuarioExterno = payload
    },
    setDepartamentos: (state, { payload }) => {
      state.loadingDepartamentos = false
      const departamentostoAdd = payload?.items
      const departamentosBySelectCopy = state.departamentos.slice()

      if (state.isDepartamentosFilterActive) {
        state.departamentos = departamentostoAdd.length
          ? departamentostoAdd
          : [{ razonSocial: "" }]
      } else {
        // @ts-expect-error TS(2322): Type 'any[]' is not assignable to type 'never[]'.
        state.departamentos = [
          ...departamentosBySelectCopy,
          ...departamentostoAdd,
        ]
      }
      state.departamentosTotalCount = payload?.totalCount
    },
    setIsDepartamentosFilterActive(state, { payload }) {
      state.isDepartamentosFilterActive = payload
    },
    setExternalEmpresaNif(state, { payload }) {
      state.externalEmpresaNif = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.fetching = true
      })
      .addCase(login.fulfilled, (state, { payload }) => {
        state.fetching = false
        state.logged = payload?.success
        state.signInSuccess = payload?.success
        state.email = payload?.email
        state.userId = payload?.userId
      })
      .addCase(login.rejected, (state) => {
        state.fetching = false
        state.signInSuccess = false
      })
      .addCase(fetchMiUsuarioYEmpresas.pending, (state) => {
        state.loadingUserEmpresas = true
        state.loadingUserData = true
      })
      .addCase(
        fetchMiUsuarioYEmpresas.fulfilled,
        (state, { payload }: $TSMigrationFixMe) => {
          state.logged = true
          state.signInSuccess = true
          state.empresaActiva = payload.usuario.empresaActiva
          state.email = payload.usuario.email
          state.id = payload.usuario.id
          state.identityId = payload.usuario.identityId
          state.personaId = payload.usuario.personaId
          state.verificado = payload.usuario.verificacionEmpresa.verificado
          state.invitado = payload.usuario.invitado
          state.empresas = payload.empresas
          state.loadingUserEmpresas = false
          state.loadingUserData = false
        }
      )
      .addCase(fetchMiUsuarioYEmpresas.rejected, (state) => {
        state.loadingUserEmpresas = false
        state.loadingUserData = false
        state.logged = false
      })
      .addCase(loginUsuarioExterno.pending, (state) => {
        state.loadingUsuarioExterno = true
      })
      .addCase(loginUsuarioExterno.rejected, (state) => {
        state.loadingUsuarioExterno = false
      })
      .addCase(loginUsuarioExterno.fulfilled, (state, { payload }) => {
        state.loadingUsuarioExterno = false
        state.loadingUserData = false
        state.logged = true
        state.empresaActiva = payload.empresaActiva
        state.email = payload.email
        state.id = payload.id
      })
      .addCase(sendResetPasswordConfirmation.pending, (state) => {
        state.loadingResetPassword = true
      })
      .addCase(sendResetPasswordConfirmation.rejected, (state) => {
        state.loadingResetPassword = false
      })
      .addCase(sendResetPasswordConfirmation.fulfilled, (state) => {
        state.loadingResetPassword = false
      })
      .addCase(resetPassword.pending, (state) => {
        state.loadingResetPassword = true
      })
      .addCase(resetPassword.rejected, (state) => {
        state.loadingResetPassword = false
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loadingResetPassword = false
      })
      .addCase(
        logoutIfUserIsAlreadyConnected.fulfilled,
        (state, { payload }) => {
          state.showLogoutModal = payload.logout
          state.logged = !payload.logout
        }
      )
      .addCase(
        userIsVerificado.fulfilled,
        (state: $TSMigrationFixMe, { payload }) => {
          state.verificado = payload
        }
      )
      .addCase(
        fethDepartamentosBySelectFilter.pending,
        (state: $TSMigrationFixMe) => {
          state.fetchingClientesBySelect = true
        }
      )
      .addCase(
        fethDepartamentosBySelectFilter.rejected,
        (state: $TSMigrationFixMe) => {
          state.fetchingClientesBySelect = false
        }
      )
      .addCase(fetchUsuarioEmpresaActiva.fulfilled, (state, { payload }) => {
        state.empresaActiva = payload.usuario.empresaActiva
      })
      .addCase(fetchUsersByFilter.pending, (state) => {
        state.usersLoading = true
      })
      .addCase(fetchUsersByFilter.fulfilled, (state, { payload }) => {
        state.users = payload
        state.usersLoading = false
      })
      .addCase(fetchUsersByFilter.rejected, (state) => {
        state.usersLoading = false
      })
      .addCase(fetchCessionPendding.pending, (state) => {
        state.cesionPendding = false
      })
      .addCase(fetchCessionPendding.fulfilled, (state, { payload }) => {
        state.cesionPendding = payload
        state.usersLoading = false
      })
      .addCase(fetchCessionPendding.rejected, (state) => {
        state.usersLoading = false
      })
      .addCase(fetchAutorizacionesPendding.pending, (state) => {
        state.autorizacionesPendding = false
      })
      .addCase(fetchAutorizacionesPendding.fulfilled, (state, { payload }) => {
        state.autorizacionesPendding = payload
        state.usersLoading = false
      })
      .addCase(fetchAutorizacionesPendding.rejected, (state) => {
        state.usersLoading = false
      })
      .addCase(fetchCesionesAny.pending, (state) => {
        state.cesionAny = false
      })
      .addCase(fetchCesionesAny.fulfilled, (state, { payload }) => {
        state.cesionAny = payload
        state.usersLoading = false
      })
      .addCase(fetchCesionesAny.rejected, (state) => {
        state.usersLoading = false
      })
  },
})

export const {
  logout,
  setUserInfo,
  setLoadingUsuarioExterno,
  setShowLogoutModal,
  setDepartamentos,
  setIsDepartamentosFilterActive,
  setEmpresaActivaDigitosCuentasContables,
  setExternalEmpresaNif,
} = userSlice.actions

export const userSelector = (state: $TSMigrationFixMe) => state.user

export const getEmpresaActivaId = (state: $TSMigrationFixMe) =>
  state.user.empresaActiva.id
